import React from 'react';
import { mergeDeepRight } from 'ramda';
import { ThemeProvider } from 'styled-components';
import { FontFaceDefinitions } from './global';
import { bento, BentoTheme } from './themes/themes';
import { useThemeMode } from './hooks';

type DeepPartial<T> = {
    [P in keyof T]?: DeepPartial<T[P]>;
};
export type BentoThemeOverride<Theme = BentoTheme> = {
    light?: DeepPartial<Theme>;
    dark?: DeepPartial<Theme>;
};

export type BentoProviderProps<Theme = BentoTheme> = {
    mode?: 'light' | 'dark' | 'auto';
    theme?: BentoThemeOverride<Theme>;
};
export function BentoProvider<Theme>({
    mode = 'light',
    theme = {},
    children,
}: BentoProviderProps<Theme> & { children?: React.ReactNode }) {
    const autoselectedMode = useThemeMode();
    const themeMode = mode === 'auto' ? autoselectedMode : mode;
    return (
        <ThemeProvider theme={mergeDeepRight({ bento: bento[themeMode] }, theme[themeMode] || {})}>
            <>
                <FontFaceDefinitions />
                {children}
            </>
        </ThemeProvider>
    );
}
